$(function() {
  "use strict";
  
  theme.init();
  
});

$(document).on('cart.requestStarted', function(event, cart) {

});

$(document).on('cart.requestComplete', function(event, cart) {
  theme.checkCart(cart);
});

$(document).on('cart.ready', function(event, cart) {
  theme.checkCart(cart);
});

theme.checkCart = function(cart) {
  if (cart.item_count > 0) {
  	$('.header-cart').addClass('active');
  } else {
  	$('.header-cart').removeClass('active');
  }
}

theme.init = function() {
    
  if (typeof CartJS != 'undefined') {
    CartJS.init(theme.cart(), {
      "debug": true,
      "requestBodyClass": "loadingCart",
      "moneyFormat": $('body').data('cartjs-money-format'),
      "moneyWithCurrencyFormat": $('body').data('cartjs-money-with-currency-format')
    });

    rivets.bind(jQuery('.cart-holder, #cartform'), {cart: CartJS.cart});
  }

  $('.has-dropdown').on('mouseenter', function(){
    theme.repositionDropdown($(this).find('.dropdown'));
  });
  $('.has-dropdown').on('mouseleave', function(){
    theme.resetDropdown($(this).find('.dropdown'));
  });

  theme.liveSearch();
  theme.toggleClass();
  theme.slideshow();
  theme.parallax();
  theme.collection();
  theme.addToCart();
  if (theme.template == 'product') {
  	theme.productPage();
    theme.barAddToCart();
  }
  
  theme.account();
  theme.instagram();
}

theme.repositionDropdown = function($dropdown) {
  var windowWidth, dropdownOffsetLeft, dropdownOffsetRight, dropdownWidth, containerWidth, containerOffsetLeft, containerOffsetRight, containerPadding, visibleDropdownWidth, offScreenDropdown;

  windowWidth 		= $(window).width();
  dropdownWidth 		= $dropdown.innerWidth();
  containerWidth 		= $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').width() : $('.navigation-wrapper > .container-fluid').width();
  containerInnerWidth = $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').innerWidth() : $('.navigation-wrapper > .container-fluid').innerWidth();

  dropdownOffsetLeft 	 = $dropdown.offset().left;
  dropdownOffsetRight  = (windowWidth - (dropdownOffsetLeft + dropdownWidth));
  containerOffsetLeft  = $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').offset().left : $('.navigation-wrapper > .container-fluid').offset().left;
  containerOffsetRight = (windowWidth - (containerOffsetLeft + containerInnerWidth));

  containerPadding 	 = (containerInnerWidth - containerWidth) / 2;
  dropdownPlusOffsetRight = windowWidth - dropdownOffsetLeft;
  offScreenDropdown  	 = dropdownWidth - dropdownPlusOffsetRight;

  //690 930 960
  if (windowWidth > 767) {
    if (theme.isFullDropdown(dropdownWidth)) {
      $dropdown.css('left', (dropdownOffsetLeft+offScreenDropdown)/-2);
    }

    if ((!theme.isFullDropdown(dropdownWidth)) && (dropdownOffsetLeft < 30)) {
      $dropdown.css('right','auto');
      $dropdown.css('left','0');
    }

    if ((!theme.isFullDropdown(dropdownWidth)) && (dropdownOffsetRight < 30)) {
      $dropdown.css('right','0');
      $dropdown.css('left','auto');
    }
  }
}
theme.resetDropdown = function($dropdown) {
  $dropdown.css('left', 'auto');
}
theme.isFullDropdown = function(dropdownWidth) {
  if (dropdownWidth == 690 || dropdownWidth == 930 || dropdownWidth == 960) {
      return true;
  } else {
      return false;
  }
}
theme.liveSearch = function() {
  var e = null;
  $('form[action="/search"]').each(function() {
      var t = $(this).find('input[name="q"]');
      t.on("focus", function() {
          $(this).closest("form").find(".search-results").fadeIn(200)
      }), t.attr("autocomplete", "off").bind("keyup change focus", function() {
          var t = "*" + $(this).val() + "*",
              a = $(this).closest("form"),
              s = "/search?type=product&q=" + t,
              n = a.find(".search-results");
          t.length > 3 && t != $(this).attr("data-old-term") && ($(this).attr("data-old-term", t), null != e && e.abort(), e = $.getJSON(s + "&view=json", function(e) {
              n.empty(), 0 == e.results_count ? (n.empty().append('<li><div class="uk-placeholder">0 results for ' + t + "</div></li>"), n.fadeIn(200)) : ($.each(e.results, function(e, t) {
                  var a = $("<a></a>").attr("href", t.url);
                  a.append('<span class="thumbnail"><img src="' + t.thumbnail + '" />'), a.append('<div class="uk-text-left"><span class="title">' + t.title + "</span></div>"), a.append('<div class="price new_price"><span>' + t.new_price + "</span>"), "0.00lei" != t.old_price && a.append('<div class="price old_price"><s>' + t.old_price + "</s></div>"), a.wrap("<li></li>"), n.append(a.parent())
              }), e.results_count > 5 && n.append('<li><span class="title"><a href="' + s + '">See all results (' + e.results_count + ")</a></span></li>"), n.fadeIn(200))
          }))
      })
  })
  $('form[action="/search"]').find('input[name="q"]').on("focusout", function() {
      setTimeout(function() {
          $(".search-results").hide(), $(".search-backdrop").fadeOut(200)
      }, 200)
  })
}

theme.toggleClass = function() {
  var $toggler = $('.toggle-class');
  $toggler.on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    var $target = $($(this).attr('href'));
  	$target.toggleClass('active');
  });
}

theme.slideshow = function() {
  if ($('.slideshow').length > 0) {
      $('.slideshow').each(function(index){
          var $slideshow, $slides, options, $animate;

        $slideshow = $(this);
        $slides = $slideshow.find('.slides');

        options = {
            prevNextButtons: true,
            pageDots: true,
            cellSelector: '.slide',
            cellAlign: 'left',
            contain: true,
            autoPlay: false,
            adaptiveHeight: true,
            freeScroll: false,
            wrapAround: true,
            draggable: true,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 65, y2: 45,
              x3: 20
            },
            on: {
                ready: function() {
                    $animate = $slideshow.find('.slide:first-child .slide-caption .animate');
                    //theme.animateSlideshowCaption($animate, .2, .3, 0, 1);

                    var previousIndex = $slideshow.find('.slide').filter('.is-previous').data('index') != undefined ? $slideshow.find('.slide').filter('.is-previous').data('index') : $slideshow.find('.slide').filter('.is-previous').index();
                    var nextIndex = $slideshow.find('.slide').filter('.is-next').data('index') != undefined ? $slideshow.find('.slide').filter('.is-next').data('index') : $slideshow.find('.slide').filter('.is-next').index();
                    $slideshow.find('.slideshow-arrow.previous .index').empty().append(previousIndex);
                    $slideshow.find('.slideshow-arrow.next .index').empty().append(nextIndex);
                    $slideshow.find('.slideshow-arrow.previous .title').empty().append($slideshow.find('.slide').filter('.is-previous').data('title'));
                    $slideshow.find('.slideshow-arrow.next .title').empty().append($slideshow.find('.slide').filter('.is-next').data('title'));

                    if ($slideshow.data('items') === undefined || $slideshow.data('items') === '') {

                    } else {
                        if ($slideshow.find('.slide').length <= $slideshow.data('items')) {
                            $slideshow.find('.slideshow-arrow').remove();
                            $slideshow.find('.slideshow-navigation').remove();
                        }
                    }
                },
                change: function(index) {
                    var index = index+1;
                    $slideshow.find('.slide .slide-caption .animate').removeAttr('style');
                    $animate = $slideshow.find('.slide:nth-child('+index+') .slide-caption .animate');
                    //theme.animateSlideshowCaption($animate, .2, .3, 0, 1);

                    var previousIndex = $slideshow.find('.slide').filter('.is-previous').data('index') != undefined ? $slideshow.find('.slide').filter('.is-previous').data('index') : $slideshow.find('.slide').filter('.is-previous').index();
                    var nextIndex = $slideshow.find('.slide').filter('.is-next').data('index') != undefined ? $slideshow.find('.slide').filter('.is-next').data('index') : $slideshow.find('.slide').filter('.is-next').index();
                    $slideshow.find('.slideshow-arrow.previous .index').empty().append(previousIndex);
                    $slideshow.find('.slideshow-arrow.next .index').empty().append(nextIndex);
                    $slideshow.find('.slideshow-arrow.previous .title').empty().append($slideshow.find('.slide').filter('.is-previous').data('title'));
                    $slideshow.find('.slideshow-arrow.next .title').empty().append($slideshow.find('.slide').filter('.is-next').data('title'));
                }
            }
        }

        if (typeof $slideshow.data('wrap-around') == 'boolean') {
            options.wrapAround = $slideshow.data('wrap-around');
        }

        if (typeof $slideshow.data('adaptive-height') == 'boolean') {
            options.adaptiveHeight = $slideshow.data('adaptive-height');
        }

        if (typeof $slideshow.data('auto-play') == 'boolean') {
            options.autoPlay = $slideshow.data('auto-play');
        } else if (typeof $slideshow.data('auto-play') == 'number') {
            options.autoPlay = $slideshow.data('auto-play');
        }

        if (typeof $slideshow.data('free-scroll') == 'boolean') {
            options.freeScroll = $slideshow.data('free-scroll');
        }

        if (typeof $slideshow.data('draggable') == 'boolean') {
            options.draggable = $slideshow.data('draggable');
        }

        if (typeof $slideshow.data('group-cells') == 'boolean' || typeof $slideshow.data('group-cells') == 'number') {
            options.groupCells = $slideshow.data('group-cells');
        }

        if (typeof $slideshow.data('lazy-load') == 'boolean') {
            options.lazyLoad = $slideshow.data('lazy-load');
        }

        if (typeof $slideshow.data('initial-index') == 'number') {
            options.initialIndex = $slideshow.data('initial-index');
        }	

        var $slider = $slides.flickity(options);
    });
  }
}

theme.parallax = function() {
  if ($('.parallax').hasClass('parallax-true')){
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() > 798) {
      skrollr.init({forceHeight: false});
      var s = skrollr.init({forceHeight: false});
      s.refresh($(".parallax"));
    } else if ($(window).width() > 798) {
      $('.parallax').removeClass('parallax-true').addClass('parallax-false');
    }
  }
}

theme.collection = function() {
  if ($('.template-collection').length > 0) {
    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body').on('change', '#sort-by', function() {
        theme.filter();
    });
    
    $('body').on('change', '.sidebar [data-filter]', function(e) {
      e.preventDefault();
      var $input = $(this).find('input');
      if ($input.prop('checked')) {
      	$(this).parents('li').addClass('active');
      } else {
      	$(this).parents('li').removeClass('active');
      }
      theme.filter();
    });
  }
}

theme.filter = function() {
  $('.collection-page').addClass('loading-products');

  var selectedOptions = [],
      query = '',
      currentTags = '',
      siteUrl = 'https://' + $.url('hostname'),
      url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
      url2 = $.url('2') ? $.url('2') + '/' : '',
      url3 = $.url('3'),
      path = url1 + url2;


  //Handle dropdowns if they exist
  if ($('#sort-by').length){
    query = $('#sort-by').val();
  } else {
    query = $.url('?sort_by');
  }
  
  //Add all checkbox values to array
  $('.sidebar [data-filter] input:checked').each(function (){
    selectedOptions.push($(this).val());
  });
  
  selectedOptions = $.makeArray(selectedOptions);
  //Loop through tags to create string to update page url
  $.each(selectedOptions, function(i, value){
    if (i != selectedOptions.length - 1) {
      currentTags += selectedOptions[i] + '+';
    } else {
      currentTags += selectedOptions[i];
    }
  });

  Shopify.queryParams.sort_by = query;
  query = '?' + $.param(Shopify.queryParams);
  theme.processUrl(path, currentTags, query);
}

theme.updateView = function(filterURL) {
  $.ajax({
     type: 'GET',
     url: filterURL,
     beforeSend: function() {
        $('html, body').animate({
            scrollTop: $(".collection-page").offset().top
        }, 500);
     },
     success: function(data) {
       $('.collection-page').removeClass('loading-products');

        var paginationElement = $(data).find('.pagination-holder').html();
        if ($(data).find('.pagination-holder').length > 0) {
          if ($('.pagination-holder').length>0) {
              $('.pagination-holder').html(paginationElement).show();
          } else {
              $('.pagination-holder').insertAfter('#products-container').show();
          }
        } else {
          if ($('.pagination-holder').length>0) {
              $('.pagination-holder').hide();
          }
        }

        var filteredData = $(data).find('#products-container').html();
        $('#products-container').html(filteredData);
       
        var filteredSidebar = $(data).find('.sidebar').html();
        $('.sidebar').html(filteredSidebar);
       
        var filteredToolbarInfo = $(data).find('#toolbar-info').html();
        $('#toolbar-info').html(filteredToolbarInfo);

        window.history && window.history.pushState && window.history.pushState("", "", filterURL);
     },
     error: function(x, t, m) {
      location.replace(location.protocol + '//' + location.host + filterURL);

     },
     dataType: "html"
  });
}

theme.processUrl = function(path, tags, query) {
  var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';
  urlString = path + tags + query;
  theme.updateView(urlString);
}

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

theme.productPage = function() {
  var $primary = $('.main-images'),
      $secondary = $('.secondary-images');
  if ( $primary.length > 0 ) {
    $primary.flickity({
        // options
        lazyLoad: true,
        cellAlign: 'left',
        "arrowShape": { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        },
        contain: true,
        imagesLoaded: true,
        adaptiveHeight: true,
        dragThreshold: 10,
        selectedAttraction: 0.01,
        friction: 0.15,
        pageDots: false
    });
  }
  if ( $secondary.length > 0 ) {
    $secondary.flickity({
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        adaptiveHeight: true,
        dragThreshold: 10,
        selectedAttraction: 0.01,
        friction: 0.15,
        pageDots: false,
        asNavFor: '.main-images',
        prevNextButtons: false
    });
  }
  
  if ($('.product-images').data('lightbox') == true) {
  	$('.main-images a').magnificPopup({
        type: 'image',
      	mainClass: 'mfp-with-zoom', // this class is for CSS animation below
        zoom: {
          enabled: true, // By default it's false, so don't forget to enable it
          duration: 300, // duration of the effect, in milliseconds
          easing: 'ease-in-out', // CSS transition easing function

          // The "opener" function should return the element from which popup will be zoomed in
          // and to which popup will be scaled down
          // By defailt it looks for an image tag:
          opener: function(openerElement) {
            // openerElement is the element on which popup was initialized, in this case its <a> tag
            // you don't need to add "opener" option if this code matches your needs, it's defailt one.
            return openerElement.is('img') ? openerElement : openerElement.find('img');
          }
        }
    });
  }
  if ($('.product-images').data('zoom') == true) {
    var to_Zoom = $('.main-images .slide');
    theme.zoomThis(to_Zoom);
  }
  
  $(window).on('scroll', function() {
  	var offsetTop = $('.section-template-product .add-to-cart').offset().top,
        windowScrollTop = $(window).scrollTop();
    
    if (windowScrollTop < offsetTop && $('.product-bar').hasClass('active') === true) {
      $('.product-bar').removeClass('active');
    } else if (windowScrollTop > offsetTop && $('.product-bar').hasClass('active') === false) {
      $('.product-bar').addClass('active');
    }
  });
}

theme.zoomThis = function(selectorParent) {
  $(selectorParent).each(function() {
      var large_img = $(this).find('img').data('zoom');
      $(this).find('img').wrap('<span style="display:block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
          url: large_img,
          touch: false,
          on: 'mouseover',
          duration: 200
      });
  });
}

theme.barAddToCart = function() {
  var $modal = $('#product-status');
  $('body').on('click', '.bar-add-to-cart', function(e) {
    e.preventDefault();
    
    var variantID = $(this).attr('data-add'),
        $addToCart = $(this),
        qty = $('.js-product-form').find(".quantity").length > 0 ? $('.js-product-form').find(".quantity").val() : 1,
        modalBody = '';
    
    $addToCart.attr('disabled', 'disabled');
    $addToCart.find('.add').addClass('d-none');
    $addToCart.find('.adding').removeClass('d-none');
    
    CartJS.addItem(variantID, qty,{
    
    },{
        "success": function(data, textStatus, jqXHR) {
          $addToCart.find('.adding').addClass('d-none');
          $addToCart.find('.added').removeClass('d-none');

          setTimeout(function(){
            $addToCart.find('.added').addClass('d-none');
            $addToCart.find('.add').removeClass('d-none');
            $addToCart.removeAttr('disabled');
          }, 1000);
          
          
            modalBody += '<div class="row">';
              modalBody += '<div class="col-4">';
                modalBody += '<img src="'+jqXHR.responseJSON.image+'">';
              modalBody += '</div>';
              modalBody += '<div class="col-8">';
              if (jqXHR.responseJSON.variant_title != null) {
                modalBody += '<p><strong>'+jqXHR.responseJSON.product_title+' - '+jqXHR.responseJSON.variant_title+'</strong> was successfully added to your cart!</p>';
              } else {
                modalBody += '<p><strong>'+jqXHR.responseJSON.product_title+'</strong> was successfully added to your cart!</p>';
              }
              modalBody += '</div>';
            modalBody += '</div>';

            $modal.find('.modal-title').empty().append('Product Added!');
            $modal.find('.modal-body').empty().append(modalBody);
            $modal.find('.error-actions').addClass('d-none');
            $modal.find('.success-actions').removeClass('d-none');
            $modal.modal('show');
          
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          $addToCart.find('.error .text').empty().append(jqXHR.responseJSON.message);
        
          $addToCart.find('.adding').addClass('d-none');
          $addToCart.find('.error').removeClass('d-none');

          setTimeout(function(){
            $addToCart.find('.error').addClass('d-none');
            $addToCart.find('.add').removeClass('d-none');
            $addToCart.removeAttr('disabled');
          }, 1000);

          
            $modal.find('.modal-title').empty().append('We\'re sorry!');
            $modal.find('.modal-body').empty().append(jqXHR.responseJSON.description);
            $modal.find('.success-actions').addClass('d-none');
            $modal.find('.error-actions').removeClass('d-none');
            $modal.modal('show');
          
        }
    });
  });
}

theme.addToCart = function() {
  var $modal = $('#product-status');
  $('body').on('submit', ".js-product-form", function(e) {
    e.preventDefault();

    var $form = $(this),
        $addToCart = $form.find('.add-to-cart'),
    	id = $form.find("[name='id']").val(),
        qty = $form.find(".quantity").length > 0 ? $(this).find(".quantity").val() : 1,
        modalBody = '';
    
    $addToCart.attr('disabled', 'disabled');
    $addToCart.find('.add').addClass('d-none');
    $addToCart.find('.adding').removeClass('d-none');
    
    CartJS.addItem(id, qty, {

    },{
      "success": function(data, textStatus, jqXHR) {
        
		$addToCart.find('.adding').addClass('d-none');
        $addToCart.find('.added').removeClass('d-none');
        
        setTimeout(function(){
          $addToCart.find('.added').addClass('d-none');
          $addToCart.find('.add').removeClass('d-none');
          $addToCart.removeAttr('disabled');
        }, 1000);
        
        
          modalBody += '<div class="row">';
            modalBody += '<div class="col-4">';
              modalBody += '<img src="'+jqXHR.responseJSON.image+'">';
            modalBody += '</div>';
            modalBody += '<div class="col-8">';
            if (jqXHR.responseJSON.variant_title != null) {
              modalBody += '<p><strong>'+jqXHR.responseJSON.product_title+' - '+jqXHR.responseJSON.variant_title+'</strong> was successfully added to your cart!</p>';
            } else {
              modalBody += '<p><strong>'+jqXHR.responseJSON.product_title+'</strong> was successfully added to your cart!</p>';
            }
            modalBody += '</div>';
          modalBody += '</div>';

          $modal.find('.modal-title').empty().append('Product Added!');
          $modal.find('.modal-body').empty().append(modalBody);
          $modal.find('.error-actions').addClass('d-none');
          $modal.find('.success-actions').removeClass('d-none');
          $modal.modal('show');
        
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        
        $addToCart.find('.error .text').empty().append(jqXHR.responseJSON.message);
        
		$addToCart.find('.adding').addClass('d-none');
        $addToCart.find('.error').removeClass('d-none');
        
        setTimeout(function(){
          $addToCart.find('.error').addClass('d-none');
          $addToCart.find('.add').removeClass('d-none');
          $addToCart.removeAttr('disabled');
        }, 1000);
        
        
          $modal.find('.modal-title').empty().append('We\'re sorry!');
          $modal.find('.modal-body').empty().append(jqXHR.responseJSON.description);
          $modal.find('.success-actions').addClass('d-none');
          $modal.find('.error-actions').removeClass('d-none');
          $modal.modal('show');
        
      }
    });

  });
  
  
    $modal.on('hidden.bs.modal', function (event) {
      $modal.find('.modal-title').empty();
      $modal.find('.modal-body').empty();
      $modal.find('.error-actions').addClass('d-none');
      $modal.find('.success-actions').addClass('d-none');
    });
  
  
  if ($('.product-form-with-options').length > 0) {
  	new Shopify.OptionSelectors($('.product-form-with-options').data("select-id"), { product: $('.product-form-with-options').data("product"), onVariantSelected: theme.selectCallback, enableHistoryState: true });
  
    $('body').on('change', '.swatch :radio', function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product-form');

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  
  }
}

theme.selectCallback = function(variant, selector) {
  var $product = $('.product-' + selector.product.id);
  var $productForm = $('form.product-form', $product);
  
  var $productBar = $('.product-bar-' + selector.product.id);
  var $productBarForm = $('form.product-form', $productBar);
  
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $carousel = $('.main-images'),
    	index = $('[data-image-id="'+variant.featured_image.id+'"]').data('index');
    var interval = setInterval(function() {
      if ($carousel.hasClass('flickity-enabled')) {
      	$carousel.flickity( 'selectCell', index );
        clearInterval(interval);
      }
    },100); 
  }
  
  if(variant) {
    $('.bar-add-to-cart').attr('data-add', variant.id);
    if ($productForm.data('select-style') === 'swatches') {
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    }
  }
  
  var save = 'Save';
  var sale = 'Sale';
  var sold = 'Sold out';
  
  if (variant && variant.available == true) {
    if (variant.price > 0) {
      $('.current-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>').show();
      $('.current-price', $productBar).empty().append('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>').show();
    } else {
      $('.current-price', $product).empty().append('FREE').show();
      $('.current-price', $productBar).empty().append('FREE').show();
    }
    
    $('.variant-title', $productBar).empty().append(variant.title);
    
    $('.badge-sold', $product).addClass('d-none');
    $('.current-price', $product).removeClass('d-none');
    $('.badge-sold', $productBar).addClass('d-none');
    $('.current-price', $productBar).removeClass('d-none');
    if(variant.price < variant.compare_at_price){
      var amount = variant.compare_at_price - variant.price;
      $('.was-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>').removeClass('d-none');
      $('.was-price', $productBar).empty().append('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>').removeClass('d-none');
      
      
      	$('.badge-success.savings', $product).empty().append(save+' '+parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)+'%').removeClass('d-none');
      
      
    } else {
      $('.was-price', $product).addClass('d-none');
      $('.was-price', $productBar).addClass('d-none');
      
      
      	$('.badge-success.savings', $product).addClass('d-none');
      
      
    }
    
    $('.add-to-cart', $product).removeAttr('disabled');
    $('.add-to-cart', $productBar).removeAttr('disabled');
 
  } else {
    $('.badge-sold', $product).removeClass('d-none');
    $('.badge-success.amount', $product).addClass('d-none');
    $('.badge-success.savings', $product).addClass('d-none');
    $('.badge-success.text', $product).addClass('d-none');
    
    $('.add-to-cart', $product).attr('disabled', 'disabled');
    $('.add-to-cart', $productBar).attr('disabled', 'disabled');
  }
}

theme.account = function() {
  $('body').on('click', '#RecoverPassword, #HideRecoverPasswordLink', function(e) {
    e.preventDefault();
    $('#recover, #login').toggleClass('d-none');
  });
}

theme.instagram = function() {
  
  var $feed = $('.instagram');
  $feed.each(function() {
    var element = $(this).attr('id'),
    	accessToken = $('#'+element).attr('data-access-token'),
        clientID = $('#'+element).attr('data-client-ID'),
        limit = $('#'+element).attr('data-limit');
    var instagram = new Instafeed({
      target: element,
      get: 'user',
      userId: clientID,
      limit: limit,
      sortBy: 'most-recent',
      accessToken: accessToken,
      resolution: 'low_resolution',
      //template: '<div class="col-md-3 mb-4"><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></div>'
      mock: true,
      success: function(response) {
      	for (i = 0; i < response.data.length; i++) {
		  $('#'+element).find('.image-'+i).empty().append('<a href="'+response.data[i].link+'" target="_blank"><img src="'+response.data[i].images.standard_resolution.url+'" alt=""></a>')
    	}
      }
    });
    instagram.run();
  })
}


//Shopify Editor
$(document).on('shopify:section:load', function(e){
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
  /*if ($parentSection.hasClass('slideshow-section')){
    theme.slideshow();
  }*/
  theme.init();
});

$(document).on('shopify:block:select', function(e){
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
  if ($parentSection.hasClass('slideshow-section')){
    var index = $('.slide-'+e.detail.sectionId+'-'+blockId).data('index');
    $parentSection.find('.slides').flickity( 'selectCell', index );
    $parentSection.find('.slides').flickity('pausePlayer');
  }
});

$(document).on('shopify:block:deselect', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('slideshow-section')){
    $parentSection.find('.slides').flickity('unpausePlayer')
  }
});

$(document).on('shopify:section:reorder', function(e){
});

$(document).on('shopify:section:load', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:unload', function(e){
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
});

$(document).on('shopify:section:select', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  $('.shopify-section').addClass('disable');
  $parentSection.removeClass('disable').addClass('enable');
  
});

$(document).on('shopify:section:deselect', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  $('.shopify-section').removeClass('disable');
  $parentSection.removeClass('enable');
});